<script>
import compoment from '@/components/draggable/CustomComponents/Radio/DSimpleRadioPreview'
export default {
  name: 'DCommentSettingPreview',
  extends: compoment
}
</script>
